import React from 'react';
import { CokitchenProvider } from 'contexts/cokitchen.context';
import CreateCokitchenContent from './content';

const CreateCokitchenLayout = () => {
  return (
    <CokitchenProvider>
      <CreateCokitchenContent />
    </CokitchenProvider>
  );
};

export default CreateCokitchenLayout;
